import React from "react";
import { Card, Form } from "antd";

const ProfileFormGroup = ({ cardProps, formProps, children }) => {
    const handleOnChange = (changedFields) => {};

    return (
        <Card {...cardProps}>
            <Form
                name="profile"
                labelAlign="left"
                labelCol={{ span: 8, offset: 0 }}
                wrapperCol={{ span: 16 }}
                onFieldsChange={handleOnChange}
                {...formProps}
            >
                {children}
            </Form>
        </Card>
    );
};

export default ProfileFormGroup;
